import React, { Component } from 'react';
import ProgressCircle from 'core_modules/ajax-loaders/templates/progress-circle/progress-circle';
import PropTypes from 'prop-types';
import ErrorPage from 'src/universal/components/ErrorPage';
import { isServer } from 'src/universal/utils/browser-detection/index';
import { isHttpStatusSuccessful } from 'page_modules/utils/cross-page-helper.js';
import { removeAppLoadingState } from 'service_modules/utils/hide-inav';
import IdleMonitor from 'page_modules/utils/pzn-page-idle-monitor';
import { AexpPznExpiryModal } from 'core_modules/aexp-modal/aexp-modal.ux';

export const withPageSetup = routeConfigs => (WrappedComponent = null) => {
  class PageWrapper extends Component {
    constructor(props) {
      super(props);
      this.offerExpiryHandler = this.offerExpiryHandler.bind(this);

      this.state = {
        showOfferExpiryWarning: false
      };
    }

    offerExpiryHandler() {
      this.setState({ showOfferExpiryWarning: true });
    }

    componentDidMount() {
      removeAppLoadingState();
      if (!Object.keys(this.props.intlPage).length) {
        const params = {
          ...this.props.params,
          ...routeConfigs,
          shop: routeConfigs.isCorporate ? 'corporate' : 'business'
        };
        this.props.fetchData(params);
      }

      this.monitor = new IdleMonitor({
        expiryHandler: this.offerExpiryHandler
      });
    }

    componentDidUpdate() {
      const { needIdleMonitor } = this.props.intlPage || {};
      if (needIdleMonitor === true && this.monitor) {
        this.monitor.start();
      }
    }

    componentWillUnmount() {
      if (this.monitor) {
        this.monitor.stop();
        this.monitor = undefined;
      }
    }

    renderProgressCircle = () => <ProgressCircle />;

    getHomepageData = () =>
      isServer() ? this.props.router.initialData : this.props.intlPage;

    renderPageBody = () => {
      const pageData = this.getHomepageData();

      return (
        <WrappedComponent
          location={this.props.location}
          params={{
            ...this.props.params,
            ...routeConfigs,
            shop: routeConfigs.isCorporate ? 'corporate' : 'business'
          }}
          EEP={this.props.EEP}
          dispatch={this.props.dispatch}
          fetchData={this.props.fetchData}
          {...pageData}
        />
      );
    };

    renderErrorPage = () => {
      const homePageData = this.getHomepageData();
      return (
        <ErrorPage intlPage={homePageData.page} globalData={homePageData.global} />
      );
    };

    checkStatus = () => this.getHomepageData().httpStatus;

    render() {
      const status = this.checkStatus();

      let pageContent;

      if (status === void 0) {
        pageContent = this.renderProgressCircle();
      } else if (isHttpStatusSuccessful(status)) {
        pageContent = this.renderPageBody();
      } else {
        pageContent = this.renderErrorPage();
      }

      if (this.state.showOfferExpiryWarning === true) {
        return (
          <div>
            {pageContent}
            <AexpPznExpiryModal
              buttonClick={() => {
                window.location.reload();
              }}
            />
          </div>
        );
      } else {
        return pageContent;
      }
    }
  }

  PageWrapper.contextTypes = {
    store: PropTypes.object.isRequired
  };

  return PageWrapper;
};
